import DefaultLoader from '@/components/UI/DefaultLoader.vue';
import NoDataMessage from '@/components/UI/NoDataMessage.vue';

export default {
    DefaultLoader: DefaultLoader,
    NoDataMessage: NoDataMessage
}